import { render, staticRenderFns } from "./AdvertisementBanner.vue?vue&type=template&id=5fe84280&scoped=true"
import script from "./AdvertisementBanner.vue?vue&type=script&lang=js"
export * from "./AdvertisementBanner.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementBanner.vue?vue&type=style&index=0&id=5fe84280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe84280",
  null
  
)

export default component.exports